import { css } from '@emotion/css'
import { Star } from 'images/Star'
import { StarActive } from 'images/StarActive'
import { minScreen } from 'utils/mediaQueries'
import { Color } from 'utils/variables'
import { buttonInteraction } from 'utils/mixin'

export const head = css`
  padding: 0 22px 17px;
  box-sizing: border-box;
  text-align: center;
  border-bottom: solid 1px #ebebeb;
`;
export const body = css`
  text-align: center;
`;

export const title = css`
  margin: 0;
  background: linear-gradient(147.36deg, #F3696E 21.73%, #F8A902 133.08%);
  display: inline-block;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  ${minScreen('md')} {
    font-size: 16px;
    line-height: 27px;
  }
`;
export const subTitle = css`
  margin: 0;
  color: ${Color.LightBlack};
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  ${minScreen('md')} {
    font-size: 16px;
    line-height: 24px;
  }
`;
export const text = css`
  margin: 0;
  color: ${Color.LightBlack};
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  ${minScreen('md')} {
    font-size: 14px;
    line-height: 21px;
  }
`;

export const stars = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const star = css`
  width: 37px;
  height: 37px;
  background-image: url(${Star});
  background-repeat: no-repeat;
  background-size: contain;
  cursor: pointer;
`;
export const starActive = css`
  background-image: url(${StarActive});
`;

export const button = css`
  margin: auto;
`;

export const urls = css`
  max-height: 110px;
  padding: 17px 20px;
  background: ${Color.LightGrey};
  border-radius: 10px;
  box-sizing: border-box;
  line-height: 1;
  overflow: scroll;
  text-align: left;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar{
    display: none;
  }
`;
export const url = css`
  margin-bottom: 9px;
  color: #227aff;
  display: inline-block;
  font-size: 11px;
  line-height: 16px;
  text-decoration: underline;
  word-break: break-all;
`;
export const urlWrap = css`
  &:last-child > a {
    margin-bottom: 0;
  }
`;

export const copy = css(
  buttonInteraction,
  css`
  max-width: 220px;
  margin: auto;
  padding: 8px 15px;
  position: relative;
  background: rgba(255, 207, 84, 0.14);
  border-radius: 9px;
  box-sizing: border-box;
  color: #ff8c68;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
`
);
export const linkIcon = css`
  margin-left: 13px;
  stroke: #ff8c68;
`;

export const logo = css`
  width: 80px;
  ${minScreen('md')} {
    width: 90px;
  }
`;

export const balloon = css`
  min-width: 100px;
  padding: 2px 3px;
  position: absolute;
  top: -90%;
  left: 50%;
  color: ${Color.White};
  font-size: 11px;
  display: inline-block;
  background: ${Color.LightBlack};
  opacity: 0;
  pointer-events: none;
  transform: translateX(-50%);
  transition: opacity 0.5s, visibility 0.5s;
  visibility: hidden;
  &::before {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -7px;
    border: 7px solid transparent;
    border-top: 7px solid ${Color.LightBlack};
  }
`;
export const balloonActive = css`
  opacity: 1;
  visibility: initial;
`;

export const errorText = css`
  margin: 0;
  color: ${Color.Red};
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
  ${minScreen('md')} {
    font-size: 14px;
    line-height: 21px;
  }
`;

export const tac = css`
  text-align: center;
`;